import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { BasePage } from "../../layout/pages/base-page";
import {
  DefaultTableAction,
  DeleteAction,
  EditAction,
  FullAddAction,
  MoveAction,
  PredefinedAddAction,
} from "../multi-level-table/multi-level-table.component";

@Component({
  selector: "app-default-actions-group",
  standalone: true,
  imports: [],
  templateUrl: "./default-actions-group.component.html",
  styleUrl: "./default-actions-group.component.scss",
})
export class DefaultActionsGroupComponent<T, M> extends BasePage implements OnInit {
  @Input() actions: DefaultTableAction<T | M>[] = [];
  @Input() item!: T;
  @Input() itemLabel: string = "";
  @Input() itemName: string = "";

  @Input() isFirst = false;
  @Input() isLast = false;

  @Output() addEvent = new EventEmitter<T | M>();
  @Output() editEvent = new EventEmitter<T>();
  @Output() moveEvent = new EventEmitter<{
    action: MoveAction<T | M>;
    item: T;
    direction: number;
  }>();
  @Output() deleteEvent = new EventEmitter<T>();

  constructor(
    protected override route: ActivatedRoute,
    protected override modal: NgbModal
  ) {
    super(route, modal);
  }
  ngOnInit(): void {
    this.actions = this.actions.sort((actionA, actionB) => {
      if (actionA.kind == "add") return -1;
      if (actionB.kind == "add") return 1;
      if (actionA.kind == "move") return -1;
      if (actionB.kind == "move") return 1;
      if (actionA.kind == "edit") return -1;
      if (actionB.kind == "edit") return 1;
      return 0;
    });
  }

  openEditModal(action: EditAction<T>) {
    if (action.canEdit(this.item) == "full") {
      action.editItem(this.item);
    } else if (action.canEdit(this.item) == "simple") {
      //TODO
    }
  }

  openAddModal(action: PredefinedAddAction<T | M> | FullAddAction<T | M>) {
    if (action.addType === "full") {
      action.saveItem(this.item).subscribe((result) => {
        if (result) {
          this.addEvent.emit(result);
        }
      });
    } else if (action.addType == "predefined") {
      //TODO
    }
  }

  showDeletePopUp(action: DeleteAction<T>) {
    this.confirm(
      `${this.itemLabel} verwijderen`,
      `Je staat op het punt om ${this.itemLabel.toLowerCase()} '${this.itemName}' definitief te verwijderen. Dit kan niet ongedaan gemaakt worden. Wil je verdergaan?`,
      `Ja, verwijder`
    )?.then((confirmed) => {
      if (confirmed) {
        action.deleteItem(this.item).subscribe((success) => {
          if (success) {
            this.deleteEvent.emit(this.item);
          }
        });
      }
    });
  }

  moveDown(action: MoveAction<T | M>) {
    this.moveEvent.emit({ action: action, item: this.item, direction: 1 });
  }

  moveUp(action: MoveAction<T | M>) {
    this.moveEvent.emit({ action: action, item: this.item, direction: -1 });
  }
}
